import React, {Suspense, lazy} from 'react';
import { isLocal } from '../../Services/helpers';

const TheAnalytics = lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "Analytics" */'./TheAnalytics'));

const Analytics = () => {
    if (isLocal()) {
        return null;
    }

    return <Suspense fallback={null}>
        <TheAnalytics />
    </Suspense>
}

export default Analytics;